import { EventActionType } from './event-action-type';

export interface CreateEventRequestAction {
  eventKey: string;
  type: EventActionType.CreateEventRequest;
}

export const createEventRequest = (
  eventKey: string,
): CreateEventRequestAction => ({
  eventKey,
  type: EventActionType.CreateEventRequest,
});
